const normalizeConceptualLabel = conceptualLabel => ({
    id: conceptualLabel.id,
    name: conceptualLabel.name,
    description: conceptualLabel.description,
    disciplineId: conceptualLabel.disciplines?.[0]?.id,
    source: conceptualLabel.source,
    creator: conceptualLabel.creator,
    createdAt: conceptualLabel.created_at,
    modifiedAt: conceptualLabel.modified_at,
    modifierId: conceptualLabel.modified_by_id,
    parentId: conceptualLabel.parent_id,
    typeId: conceptualLabel.type_id,
    visualId: conceptualLabel.visual_id,
    isActive: conceptualLabel.is_active
})

// Function to build a map of normalized conceptual labels by ID
const buildConceptualLabelMap = response => {
    return response.reduce((map, label) => {
        map[label.id] = normalizeConceptualLabel(label)
        return map
    }, {})
}

// Function to group child labels under their parent
const assignChildrenToParents = (labelMap, response) => {
    response.forEach(({ id, parent_id }) => {
        if (parent_id && labelMap[parent_id]) {
            const parent = labelMap[parent_id]
            parent.children = parent.children || []
            parent.children.push(labelMap[id])
        }
    })
}

// Function to preserve the original order and exclude unnecessary "children" properties
const buildOrderedHierarchy = (response, labelMap) => {
    return response
        .map(({ id, parent_id }) => {
            if (parent_id) return null // Skip child labels as they are already nested
            const label = labelMap[id]
            if (label.children && label.children.length === 0) {
                delete label.children // Remove empty children array for non-parent labels
            }
            return label
        })
        .filter(Boolean) // Remove skipped child labels
}

export const normalizeFetchConceptualLabelsResponse = response => {
    if (!response || !Array.isArray(response)) return []
    
    const labelMap = buildConceptualLabelMap(response) // Normalize all labels
    assignChildrenToParents(labelMap, response) // Nest child labels under parents
    return buildOrderedHierarchy(response, labelMap) // Retain order and clean structure
}

export const normalizeCreateConceptualLabelResponse = response => normalizeConceptualLabel(response)

export const normalizeUpdateConceptualLabelResponse = response => normalizeConceptualLabel(response)

export const normalizeFetchConceptualLabelDiscoveryResponse = response => {
    if (!response || !Array.isArray(response) || response.length === 0) {
        return response;
    }

    return response.map((description) => ({
        ...description,
        criteria: description.criteria.map((criterion, criterionIndex) => ({
            value: criterion,
            id: String(criterionIndex + 1),
        })),
    }));
};
